import { LocationInterface } from '../interfaces/location-interface';
import { TownInterface } from '../interfaces/town-interface';

export class Town implements TownInterface {
  // TownInterface
  id: string;
  name: string;
  townSlugs: { [lang: string]: string };
  provinceNames: Array<string>;
  provinceSlugs: Array<string>;
  countryNames: { [lang: string]: string };
  countrySlugs: Array<string>;
  furtherInformations: Array<string>;
  crossSellingLinks: Array<string>;
  location: LocationInterface;
  metaDescriptionDiscount: number;
  seoNames: { [lang: string]: string };
  relatedSaleslocations: [{ name: string; townSlugs: { [lang: string]: string } }];

  /**
   * Constructor
   *
   * @param {TownInterface} town
   */
  constructor(town: TownInterface) {
    for (const property in town) {
      if (Object.prototype.hasOwnProperty.call(town, property)) {
        this[property] = town[property];
      }
    }
  }

  /**
   * Returns the slug by the given culture,
   * NULL if not available
   *
   * @param   {string} culture
   * @returns {string | null}
   */
  getSlugByCulture(culture: string): string | null {
    if (culture in this.townSlugs) {
      return this.townSlugs[culture];
    }

    return null;
  }

  /**
   * Returns the further-information-headline for
   * the given culture, NULL if not available
   *
   * @param   {string} culture
   * @returns {string | null}
   */
  getFurtherInformationHeadline(culture: string): string | null {
    if (
      culture in this.furtherInformations &&
      this.furtherInformations[culture] &&
      'headline' in this.furtherInformations[culture]
    ) {
      return this.furtherInformations[culture]['headline'];
    }

    return null;
  }

  /**
   * Returns the further-information-text as HTML for
   * the given culture, NULL if not available
   *
   * @param   {string} culture
   * @returns {string | null}
   */
  getFurtherInformation(culture: string): string | null {
    if (
      culture in this.furtherInformations &&
      this.furtherInformations[culture] &&
      'information' in this.furtherInformations[culture]
    ) {
      return this.furtherInformations[culture]['information'];
    }

    return null;
  }

  /**
   * Returns an array of cross-selling-links for the given culture
   *
   * @param   {string} culture
   * @returns {Array<string>}
   */
  getCrossSellingLinks(culture: string): { [key: string]: string } | null {
    if (culture in this.crossSellingLinks && this.crossSellingLinks[culture]) {
      if (Array.isArray(this.crossSellingLinks[culture])) {
        return null;
      }
      return this.crossSellingLinks[culture];
    }

    return null;
  }
}
